// Type definitions for the SearchTickets query response
// This matches the structure returned by the Hasura function ticket_search_tickets

export interface SearchTicketIncidentMls {
    title: string;
    description: string | null;
    altcomponent: string | null;
}

export interface SearchTicketIncidentPersonAddress {
    street: string | null;
    housenumber: string | null;
    zip: string | null;
    city: string | null;
}

export interface SearchTicketIncidentPerson {
    __typename?: string;
    id: string;
    customerid?: string;
    name1: string;
    name2: string | null;
    mobile: string | null;
    phoneprivate: string | null;
    email: string | null;
    gender: number;
    origin: number;
    addresses?: SearchTicketIncidentPersonAddress[];
}

export interface SearchTicketIncidentPersons {
    __typename?: string;
    person: SearchTicketIncidentPerson | null;
    role: number;
}

export interface SearchTicketRealestateHouses {
    zip: string | null;
    city: string | null;
}

export interface SearchTicketRealestate {
    id: string;
    name: string;
    number: string;
    consolidation: boolean;
    houses: SearchTicketRealestateHouses[];
}

export interface SearchTicketAppliance {
    id: string;
    name: string | null;
    model: string | null;
    manufacturer: string | null;
    serialnumber: string | null;
    realestateid: string;
    unitid: string | null;
}

export interface SearchTicketUser {
    id: string;
    name1: string;
    name2: string | null;
}

export interface SearchTicketUnit {
    id: string;
    number: string | null;
    name: string | null;
    houseid: string;
}

export interface SearchTicketOrderServiceProvider {
    name1: string;
    name2: string | null;
}

export interface SearchTicketOrderPrimaryContactPerson {
    id: string;
    name1: string;
    name2: string | null;
    email: string | null;
    mobile: string | null;
    phoneprivate: string | null;
    phonebusiness: string | null;
}

export interface SearchTicketOrder {
    number: number;
    workflowinstance?: string | null;
    state?: number;
    contractortype?: number | null;
    id?: string;
    primarycontactperson?: SearchTicketOrderPrimaryContactPerson | null;
    primarycontacttype?: number | null;
    service_provider?: SearchTicketOrderServiceProvider | null;
}

export interface SearchTicketTag {
    tags_mls: { text: string };
    colorcode: string;
}

export interface SearchTicketIncident {
    id: string;
    origin: number;
    number: number;
    date: string;
    workflow_type: number; // Note: API uses workflow_type, not type
    roomtype: number | null;
    appliancetype: number | null;
    manufacturer: string | null;
    serialnumber: string | null;
    key: string | null;
    nameplate: string | null;
    state: number;
    workflowinstance: string | null;
    tags?: Array<SearchTicketTag> | null;
    tenancyid?: string | null;
    tenantid?: string | null;
    lastinboundat?: string | null;
    has_new_message?: boolean;
    incidents_mls: SearchTicketIncidentMls; // Note: Single object, not array
    incidentpersons: SearchTicketIncidentPersons[] | null; // Note: Can be null
    realestate: SearchTicketRealestate | null;
    appliance: SearchTicketAppliance | null;
    assigned_user: SearchTicketUser | null; // Note: API uses assigned_user, not user
    unit: SearchTicketUnit | null;
    orders: SearchTicketOrder[] | null; // Note: Can be null
}

// Type guard to validate the structure at
export function isSearchTicketIncident(obj: any): obj is SearchTicketIncident {
    return (
        obj &&
        typeof obj === "object" &&
        "id" in obj &&
        "number" in obj &&
        "state" in obj &&
        "incidents_mls" in obj &&
        typeof obj.incidents_mls === "object"
    );
}

// Helper to safely parse the JSONB response
export function parseSearchTicketIncidents(incidents: any): SearchTicketIncident[] {
    if (!Array.isArray(incidents)) {
        console.warn("SearchTickets incidents is not an array:", incidents);
        return [];
    }

    return incidents.filter(isSearchTicketIncident);
}
